<template>
    <div style="cursor:pointer" @click.stop="excelDownload">
        <slot/>
    </div>
</template>

<script lang="ts">
/**
 * 엑셀 추출 컴포넌트
 */
import download from 'downloadjs';

interface FileDownloadProps {
    api: string;                 // 엑셀 생성 요청 api
    // query?: any;
    query?: Record<string, any>; // 조회 파라미터
    fileName?: string;           // 다운로드 파일명
    beforeDownload?: () => Promise<boolean>;
}
</script>

<script lang="ts" setup>
const props         	    = defineProps<FileDownloadProps>();
    const emit = defineEmits<{
    (e: 'success'): void;
    (e: 'error', error:any): void;
}>();
const dialog        	    = useHconDialog();
// const authInfo      	    = useHconAuthInfo();
const fetchBuilder  	    = useHconFetchBuilder();
const apiBaseUrl    	    = useHconConfig().api.baseUrl;
const dialogMessage         = ref<string>('');
let   processId:string|null	= null;
let	  abortFlag			    = false;
let   dialogId:string|null	= null;
let   bulkProcessStatus     = {} as any;

const abortDownload		= () => {
    if (processId != null && (bulkProcessStatus.runStatus == 'READY' || bulkProcessStatus.runStatus == 'RUNNING')) {
        fetchBuilder.post<any>(`/api/v1/common/bulk/${processId}/abort`).build().execute();
    }
    abortFlag	= true;
    if (dialogId) {
        dialog.close(dialogId);
    }
}

const openDownloadStatus = async (processId:string) => {
    processId			= processId;
    let authToken       = useHconAuthInfo().getIfPossible()?.accessToken
    if (!authToken) {
        return;
    }

    const countFormater	= new Intl.NumberFormat('ko-KR');
    const statusUrl     = `${apiBaseUrl}/api/v1/common/bulk/${processId}`;
    let   response;

    try {
        response	= await fetch(statusUrl, {
            method: 'GET',
            // credentials: 'include',
            headers: {
              'Authorization' : authToken
            }
        });
    } catch (error) {
        console.debug('대량처리 상태 확인 통신 오류', error);
        emit('error', error);
    }
    const statusResContentType  = response == null ? null : response.headers.get('Content-Type');
    if (statusResContentType == null || statusResContentType.toLowerCase().indexOf('text/plain') == -1) {
        // 정상 응답 아닐시 토큰갱신 재시도
        // [hcon] 해당 API 없으므로 막아둠
        // await fetchBuilder.get('/mypage/api/v1/private/auth/whoami').build().execute();
        // authToken   = authInfo.getIfPossible()?.accessToken;
        // if (!authToken) {
        //     return;
        // }
        // response	= await fetch(statusUrl, {
        //     method: 'GET',
        //     credentials: 'include',
        //     headers: {
        //             'Authorization' : authToken
        //         }
        // });
        emit('error', 'statusResContentType is null');
    }
    if (response?.body == null) {
        emit('error', 'response body is null');
        return;
    }
    dialogMessage.value		= '파일 작성중...';
    const dialogId          = dialog.choice(dialogMessage.value, ['취소'], abortDownload);
    const reader            = response.body.getReader();
    while(true) {
        const { done, value }  = await reader.read();
        if (done) {
            break;
        }
        const raw = new TextDecoder().decode(value);
        const lines = raw.split("\n").filter(line => line.trim())
        for(const line of lines) {
            var bulkProcessStatus   = JSON.parse(line);
            dialogMessage.value 	= `${bulkProcessStatus.runStatusDetail} - 작성 ${countFormater.format(bulkProcessStatus.successCount)}건`;
            if (!abortFlag && bulkProcessStatus.runStatus == 'END_WITH_COMPLETE') {
                dialogMessage.value = '다운로드 중...';
                const fullUrl 		= cu.getFileFullUrl(bulkProcessStatus.result[0]);
                fetchBuilder.get(fullUrl).build().executeToRaw().then(res => {
                    let fileName  = 'noname.xlsx';
                    const cdh	= res.headers.get('Content-Disposition');
                    if (cdh != null) {
                        var idx = cdh.indexOf("filename*=UTF-8''");
                        if (idx > -1) {
                            fileName	= decodeURIComponent(cdh.substring(idx+17));
                        }
                    }
                    if (!abortFlag) {
                        download(res._data as Blob, fileName, 'application/otect-stream');
                        emit('success');
                    }
                    dialog.close(dialogId);
                }).catch(error => {
                    console.error(error);
                    emit('error', error);
                    dialog.alert('다운로드 처리 실패했습니다.');
                    dialog.close(dialogId);
                });
            } else if(bulkProcessStatus.runStatus == 'END_WITH_ERROR') {
                emit('error', 'END_WITH_ERROR');
            }
        }
    }
}

const excelDownload = async () => {
    console.log(">>>>>> excelDownload");

    if(props.beforeDownload) {
        try {
            const canProgress = await props.beforeDownload();
            if(!canProgress) return; 
        } catch (error) {
            emit('error', error);
            return;
        }
    }

    bulkProcessStatus	= {};
    abortFlag			= false;
    fetchBuilder.get<string>(props.api)
        .query(props.query)
        .transform<AjaxResult<string>>(res => res.data)
        .build()
        .execute()
        .then(openDownloadStatus);
}

onUnmounted(() => {
    abortDownload();
});

</script>

<style>

</style>